/* ------------------------------- bounds -------------------------------- */
/** Characters of one message from the person. */
export const AGENT_MAX_MESSAGE_CHARS = 4_000;
/** Files one message may carry. */
export const AGENT_MAX_ATTACHMENTS = 4;
/** Characters of one attachment's text (a 300-row storyboard CSV is ~50k). */
export const AGENT_MAX_ATTACHMENT_CHARS = 300_000;
/** Prior turns replayed for context; older ones are dropped, oldest first. */
export const AGENT_MAX_HISTORY_TURNS = 10;
/** Characters of one replayed turn (an answer is clipped, never a question). */
export const AGENT_MAX_HISTORY_CHARS = 2_000;
/** Row/column ids a selection may name — past this the panel sends none. */
export const AGENT_MAX_SELECTION_IDS = 2_000;
/** Ops one plan may hold. Cell writes inside an op are bounded separately. */
export const AGENT_MAX_PLAN_OPS = 100;
/** Cell values one plan may write, across every op (rows × columns counted). */
export const AGENT_MAX_PLAN_CELLS = 20_000;
/** Characters of one cell value a plan may write — the import ceiling. */
export const AGENT_MAX_CELL_CHARS = 10_000;
/**
 * A column a plan CREATES is addressed by a temporary id until the client
 * mints the real one — `add_column.colId` carries it and later ops in the
 * same plan reference it. Prefixed so it can never collide with a stable id
 * (`c` + alphanumerics — core/ids.ts).
 */
export const AGENT_TEMP_COLUMN_PREFIX = "new:";
export function isAgentTempColumnId(id) {
    return id.startsWith(AGENT_TEMP_COLUMN_PREFIX);
}
/**
 * F-150: the step tasks a file import leaves in the Agent panel — each a
 * button that proposes ONE step as a plan for the person to apply, in the
 * owner's order: split into beats, translate, align the other columns.
 */
export const IMPORT_STEP_TASKS = ["beats", "translate", "align"];
export function isImportStepTask(value) {
    return typeof value === "string" && IMPORT_STEP_TASKS.includes(value);
}
/** The language "Translate" writes (owner's call, 2026-10-08). */
export const IMPORT_TRANSLATE_TO = "en";
/** Ceiling on the groups one "Align columns" request may name. */
export const IMPORT_STEP_MAX_GROUPS = 5_000;
/* ------------------------------- helpers ------------------------------- */
/** How many cell values a plan writes — the bound `AGENT_MAX_PLAN_CELLS` is on. */
export function agentPlanCellCount(ops) {
    let n = 0;
    for (const op of ops) {
        if (op.op === "set_cells")
            n += op.cells.length;
        else if (op.op === "insert_rows") {
            for (const row of op.rows)
                n += Object.keys(row.cells).length;
        }
    }
    return n;
}
export function agentPlanCounts(ops) {
    const counts = {
        cells: 0,
        rowsAdded: 0,
        rowsDeleted: 0,
        columnsAdded: 0,
        columnsDeleted: 0,
        columnsRenamed: 0,
    };
    for (const op of ops) {
        switch (op.op) {
            case "set_cells":
                counts.cells += op.cells.length;
                break;
            case "insert_rows":
                counts.rowsAdded += op.rows.length;
                for (const row of op.rows)
                    counts.cells += Object.keys(row.cells).length;
                break;
            case "delete_rows":
                counts.rowsDeleted += op.rowIds.length;
                break;
            case "add_column":
                counts.columnsAdded += 1;
                break;
            case "delete_column":
                counts.columnsDeleted += 1;
                break;
            case "rename_column":
                counts.columnsRenamed += 1;
                break;
        }
    }
    return counts;
}
//# sourceMappingURL=agent.js.map